import EmailOrder from "../../components/email-orders/EmailOrder";
import { orderTypeOptions } from "../../constants/constants";

const PdfOrder = () => {
  // orderTypeOptions.BodyLink
  return <EmailOrder orderType={orderTypeOptions.PDF} isReprocessBtnEnabled={true}></EmailOrder>;
};

export default PdfOrder;
